<template>
  <div class="fixed-header" :class="{ mobile: $vuetify.breakpoint.smAndDown, 'with-summary': !newCaseMode }">
    <!-- if has summary fields add class 'with-summary' -->
    <v-layout align-center fill-height class="fixed-header-wrapper">
      <v-flex shrink class="text-truncate" pr-4>
        <v-tooltip color="secondary" bottom>
          <template v-slot:activator="{ on }">
            <h2 v-on="on" class="p-relative text-truncate">
              {{ pageTitle }}
            </h2>
          </template>
          <span>{{ pageTitle }}</span>
        </v-tooltip>
        <!--<h4 class="sub-header opacity-54">Subline in here if need be</h4>-->
      </v-flex>
      <v-spacer></v-spacer>
      <v-divider v-if="hasActiveServiceLevel" vertical></v-divider>
      <v-flex shrink fill-height v-if="hasActiveServiceLevel" class="sla breach"
        ><!-- if one of SLA's in jeopardy or breach add class 'jeopardy' or 'breach' here -->
        <v-tooltip color="secondary" bottom>
          <v-btn icon flat slot="activator" @click="SLADialog = true">
            <v-icon color="secondary" size="20" @click="SLADialog = true"> notifications_active </v-icon>
          </v-btn>
          <span
            ><!--{{notificationMessage}}-->
            {{ serviceLevels.length }} Service Levels</span
          >
          <!--<span> 3 Service Levels - 1 in breach</span> if one in breach or jeopardy add this to tooltip text -->
        </v-tooltip>
      </v-flex>

      <v-divider vertical v-if="firstViewer"></v-divider
      ><!-- only required if presence exists -->
      <v-flex shrink fill-height pt-2 pr-3 pl-2 class="presence" v-if="firstViewer">
        <UserAvatar status="active" :user-id="firstViewer.userId || firstViewer.id" :name="firstViewer.userDisplayName || firstViewer.displayName" avatar-only size="40px" class="expansion-avatar mr-2" v-if="firstViewer"> </UserAvatar>
        <UserAvatar status="active" :user-id="secondViewer.userId || secondViewer.id" :name="secondViewer.userDisplayName || secondViewer.displayName" avatar-only size="40px" class="expansion-avatar mr-2" v-if="secondViewer"> </UserAvatar>

        <span v-if="otherViewersOverflowCount" class="ml-1">+ {{ otherViewersOverflowCount }}</span>
      </v-flex>
      <v-divider vertical></v-divider>
      <v-flex shrink fill-height px-3 class="header-text">
        <h4 class="text-truncate opacity-54 label">Template</h4>
        <v-tooltip color="secondary" bottom>
          <template v-slot:activator="{ on }">
            <h4 v-on="on" class="text-truncate">{{ caseTypeName }}</h4>
          </template>
          <span>{{ caseTypeName }}</span>
        </v-tooltip>
      </v-flex>
      <v-flex shrink fill-height class="status header-text" px-3>
        <h4 class="text-truncate opacity-54 label">Status</h4>
        <v-tooltip color="secondary" bottom>
          <template v-slot:activator="{ on }">
            <h4 v-on="on" class="text-truncate">{{ state }}</h4>
          </template>
          <span>{{ state }}</span>
        </v-tooltip>
      </v-flex>
      <v-flex shrink fill-height class="vert-dots" v-if="!newCaseMode">
        <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
          <v-btn flat slot="activator" icon class="ma-0 pa-0" dark color="secondary">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile v-if="!isBookmarked" @click="createBookmark()"> <v-icon class="mr-2" color="secondary">bookmark</v-icon>Bookmark this case </v-list-tile>
            <v-list-tile v-if="isBookmarked" @click="removeBookmark()"> <v-icon class="mr-2" color="secondary">bookmark</v-icon>Remove bookmark </v-list-tile>
            <v-list-tile @click="deleteDialog = true" v-if="hasDeletePermission"> <v-icon class="mr-2" color="secondary">delete</v-icon>Delete case </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-dialog v-model="SLADialog" width="400"
      ><!-- Taken from CaseHeader -->
      <v-card class="pa-4">
        <v-card-title class="ma-0 mb-2 pa-0">
          <h2 class="mb-2">Service Levels</h2>
        </v-card-title>
        <div>
          <v-flex xs12 v-for="(serviceLevel, index) in serviceLevels" :key="index">
            <div>
              <v-flex v-if="serviceLevel.breachedAt" xs12 d-block class="mb-2">
                <h3 class="font-weight-bold error--text">
                  <v-icon size="21" color="error" class="ma-0 mr-2 mt-1" style="vertical-align: top"> notifications_active </v-icon>
                  {{ slaName(serviceLevel) }}
                </h3>
                <h4 class="error--text ml-4 pl-2">In breach for {{ getDuration(serviceLevel.breachedAt) }}.</h4>
              </v-flex>

              <v-flex v-if="serviceLevel.jeopardizedAt && !serviceLevel.breachedAt" xs12 d-block class="mb-2">
                <h3 class="font-weight-bold tertiary--text">
                  <v-icon size="21" color="tertiary" class="ma-0 mr-2 mt-1" style="vertical-align: top"> notifications_active </v-icon>
                  {{ slaName(serviceLevel) }}
                </h3>
                <h4 class="tertiary--text ml-4 pl-2">In Jeopardy for {{ getDuration(serviceLevel.jeopardizedAt) }}.</h4>
              </v-flex>

              <v-flex v-if="!serviceLevel.jeopardizedAt && !serviceLevel.breachedAt" xs12 d-block class="mb-2">
                <h3 class="font-weight-bold secondary--text">
                  <v-icon size="21" color="secondary" class="ma-0 mr-2 mt-1" style="vertical-align: top"> notifications_active </v-icon>
                  {{ slaName(serviceLevel) }}
                </h3>
              </v-flex>
            </div>
          </v-flex>
        </div>
        <v-card-actions class="ma-0 mt-3 pa-0">
          <v-btn @click="SLADialog = false" color="error">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2>Delete Case</h2>
        </v-card-title>
        <v-card-text class="pa-0">
          <p>Are you sure you want to delete this case?</p>
        </v-card-text>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn @click="deleteCase()" color="error">Yes, delete this case</v-btn>
          <v-btn @click="deleteDialog = false" color="secondary">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="case-summary-fields">
      <v-divider></v-divider>
      <v-layout align-center fluid fill-height>
        <v-flex grow fill-height px-4 class="summary-field-wrapper" v-for="(field, index) in summaryFields" :key="index">
          <h4 class="text-truncate opacity-54 label">{{ field.name }}</h4>
          <v-tooltip color="secondary" bottom>
            <template v-slot:activator="{ on }">
              <h4 v-on="on" class="text-truncate">{{ field.value }}</h4>
            </template>
            <span>{{ field.value }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import UserAvatar from "@/components/Users/UserAvatar.vue"
import PageTitle from "@/components/PageTitle.vue"
import CasePresenceDisplayHeader from "@/components/shared/CasePresenceDisplayHeader"
import CaseSLANotification from "@/components/cases/CaseSlaNotification"
import Helpers from "@/helpers.js"
import { mapState } from "vuex"

export default {
  name: "case-header-new",
  data: () => ({
    SLADialog: false,
    deleteDialog: false,
    flagged: false,
    schemaView: "default",
    sections: [],
    viewerMax: 2,
    viewerMin: 1,
  }),
  components: {
    PageTitle,
    CasePresenceDisplayHeader,
    CaseSLANotification,
    UserAvatar,
  },
  props: {
    initialState: String,
    hasDeletePermission: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      cbroute: (state) => state.cbroute,
      caseTypeName: (state) => Helpers.caseTypeName(state.caseTypes.current),
      caseTypes: (state) => state.caseTypes.all,
      isBookmarked: (state) => state.cases.currentlySelected.bookmarked,
      currentCase: (state) => state.cases.currentlySelected.case,
      subscriptions: (state) => state.currentUser.subscriptions,
      viewers: (state) => state.cases.currentlySelected.viewers,
      currentUserId: (state) => state.currentUser.me.id,
      preferences: (state) => state.currentUser.me.preferences,
      isLoading: (state) => state.cases.currentlySelected.loading,
      bookmarks: (state) => (state.ui.caseWorkMenu && state.ui.caseWorkMenu[0].items && state.ui.caseWorkMenu[0].items[0] && state.ui.caseWorkMenu[0].items[0].childItems && state.ui.caseWorkMenu[0].items[0].childItems ? state.ui.caseWorkMenu[0].items[0].childItems : []),
      lastCaseContainerPath: (state) => state.ui.lastCaseContainerPath,
    }),
    newCaseMode() {
      return !!this.initialState
    },
    otherViewers() {
      if (this.viewers && this.viewers.length > 1) {
        return this.viewers.filter((viewer) => viewer.id !== this.currentUserId) // Excluding current user
      } else {
        return []
      }
    },
    firstViewer() {
      if (this.otherViewers && this.otherViewers.length >= 1) {
        return this.otherViewers[0]
      } else {
        return undefined
      }
    },
    secondViewer() {
      if (this.otherViewers && this.otherViewers.length > 2) {
        return this.otherViewers[1]
      } else {
        return undefined
      }
    },
    otherViewersOverflowCount() {
      if (this.secondViewer) {
        return this.otherViewers.length - 2
      } else {
        return undefined
      }
    },
    summaryFields() {
      const fieldValues = []
      if (this.currentCase) {
        const schema = this.currentCase.schema
        if (!schema || !schema.fieldsets) {
          return fieldValues
        }
        const fields = ["summaryVal1", "summaryVal2", "summaryVal3", "summaryVal4", "summaryVal5"]
        for (const field of fields) {
          const fieldDefn = `${field}Defn`
          let valstr = this.currentCase[field] || ""
          const valDefn = this.currentCase[fieldDefn]
          if (valDefn) {
            const defn = JSON.parse(this.currentCase[fieldDefn])

            let schemaField = null
            schema.fieldsets.map((fs) => {
              return fs.fields.map((field) => {
                if (field.name === defn.name) {
                  schemaField = field
                }
                return null
              })
            })

            if (defn.name !== "title") {
              if (defn.type === "date" && valstr.length > 0) {
                if (valstr.includes('"')) {
                  // If Date arrives in quotes..
                  valstr = valstr.replace(/"/g, "")
                }
                const format = this.preferences.dateTimeFormat ? this.preferences.dateTimeFormat : "HH:MM, D MMM"
                valstr = Helpers.formatDate(valstr, format)
              } else if (defn.type === "relation") {
                try {
                  const relationValue = JSON.parse(valstr)
                  if (relationValue && relationValue.properties) {
                    valstr = Object.values(relationValue.properties).join(", ")
                  }
                } catch (error) {
                  console.error("Unable to parse summary field value.")
                  console.error(error)
                }
              } else if (defn.type === "number" && defn.display === "currency") {
                if (defn.symbol) {
                  valstr = Helpers.formatCurrency(valstr, defn.symbol, defn.precision)
                }
              }

              fieldValues.push({ name: Helpers.titleize(defn.name), value: valstr })
            }
          }
        }
      }
      return fieldValues
    },
    caseId() {
      return this.cbroute.params.case_id
    },
    hasServiceLevels() {
      return this.serviceLevels && this.serviceLevels.length > 0
    },
    hasActiveServiceLevel() {
      if (this.hasServiceLevels) {
        const actives = this.serviceLevels.filter((sla) => sla.active)
        return actives.length > 0
      } else {
        return false
      }
    },
    pageTitle() {
      if (this.newCaseMode) {
        return `New ${this.caseTypeName}`
      }
      if (this.currentCase) {
        return this.currentCase.title
      } else {
        return "TITLE "
      }
    },
    serviceLevels() {
      if (this.currentCase) {
        if (this.currentCase.serviceLevels) {
          return this.currentCase.serviceLevels
        }
      }
      return []
    },
    state() {
      if (this.newCaseMode) {
        return this.initialState
      }
      if (this.currentCase) {
        return this.currentCase.currentState
      } else {
        return "STATE"
      }
    },
    flagColor() {
      if (this.flagged) {
        return "success"
      } else {
        return "grey darken-1"
      }
    },
    notificationsEnabled() {
      const subs = this.subscriptions.filter((sub) => sub.caseId === this.caseId)
      return subs && subs.length && subs.length > 0
    },
    overdueSlas() {
      let result = "Service Level Agreements"
      if (this.serviceLevels) {
        let count = 0
        this.serviceLevels.forEach((sla) => {
          if (sla.jeopardizedAt || sla.breachedAt) {
            count++
          }
        })
        if (count > 0) {
          result = count + " Overdue SLA"
        }
      }
      return result
    },
    slaColour() {
      let result = "primary"
      if (this.serviceLevels) {
        let jeopardy = 0
        let breach = 0
        this.serviceLevels.forEach((sla) => {
          if (sla.jeopardizedAt) {
            jeopardy++
          }
          if (sla.breachedAt) {
            breach++
          }
        })

        if (jeopardy > 0) {
          result = "tertiary"
        }
        if (breach > 0) {
          result = "error"
        }
      }
      return result
    },
    orderedHeaders() {
      const fieldsets = []
      if (this.currentCase === null || this.currentCase === undefined) {
        return []
      }
      if (this.currentCase.schema === null || this.currentCase.schema === undefined) {
        return []
      }
      if (this.currentCase.schema.case_data_views) {
        this.currentCase.schema.case_data_views.edit.rows.forEach(function (row) {
          row.columns.forEach(function (column) {
            fieldsets.push(column.fieldset)
          })
        })
      } else {
        this.currentCase.schema.fieldsets.forEach(function (header) {
          fieldsets.push(header.name)
        })
      }
      return fieldsets
    },
  },
  mounted() {
    this.onResize()
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    async createBookmark() {
      const result = await this.$store.dispatch("createBookmark", {
        route: this.$route.fullPath,
        linkText: this.pageTitle,
      })
      if (result) {
        this.$store.commit("setCaseBookmarked", true)
      }
    },
    async removeBookmark() {
      let id
      this.bookmarks.forEach((bookmark) => {
        if (bookmark.route === this.$route.fullPath) {
          id = bookmark.id
        }
      })
      if (id > 0) {
        const result = await this.$store.dispatch("deleteBookmark", { id })
        if (result) {
          this.$store.commit("setCaseBookmarked", false)
        }
      } else {
        this.$store.commit("displayFlashMessage", {
          message: "ID not found, cannot delete..",
          severity: "error",
        })
      }
    },
    slaName(serviceLevel) {
      if (serviceLevel && serviceLevel.serviceLevelCriteria && serviceLevel.serviceLevelCriteria.name) {
        return serviceLevel.serviceLevelCriteria.name
      }
      return "Untitled Service Level"
    },
    getDuration(fromDate) {
      return Helpers.calculateTimeDifferenceFromNow(fromDate)
    },
    onResize() {
      let max
      if (this.$vuetify.breakpoint.smAndDown) {
        max = Math.floor(window.innerWidth / 100) + 2 // Mobile max
      } else {
        max = Math.floor(window.innerWidth / 100) - 10 // Desktop max
      }
      if (this.viewerMax !== max) {
        if (max >= this.viewerMin) {
          this.viewerMax = max
        } else {
          this.viewerMax = this.viewerMin
        }
      }
    },
    async deleteCase() {
      this.deleteDialog = false
      const result = await this.$store.dispatch("deleteCase", parseInt(this.currentCase.id))
      if (result) {
        if (this.lastCaseContainerPath && this.lastCaseContainerPath.length > 0) {
          this.$router.push(this.lastCaseContainerPath.pop())
        } else {
          this.$router.push({ name: "Dashboard" })
        }
      }
    },
  },
}
</script>
<style>
.offset-top {
  margin-top: 110px;
}

.offset-top.with-summary {
  margin-top: 170px;
}

.mini .fixed-header {
  width: calc(100% - 55px);
}

.fixed-header {
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0;
  background: white;
  height: 60px;
  top: 50px;
  right: 0;
  width: calc(100% - 300px);
  position: fixed;
  z-index: 30;
  -webkit-box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.fixed-header.with-summary {
  height: 120px;
}

.fixed-header-wrapper {
  height: 60px;
  padding: 0 0 0 24px;
}

.fixed-header.mobile {
  width: 100%;
}

.fixed-header .vert-dots {
  width: 60px;
}

.fixed-header .vert-dots .v-menu {
  width: 60px;
  height: 60px;
}

.fixed-header .sla,
.fixed-header .action {
  width: 60px;
  min-width: 60px;
}

.fixed-header .action-wide {
  width: 120px;
  min-width: 120px;
}

.fixed-header .sla.breach {
  background: #db444d;
  background: -webkit-gradient(linear, left top, left bottom, from(#db444d), to(#af1f2e));
  background: linear-gradient(to bottom, #db444d 0%, #af1f2e 100%);
}

.fixed-header .sla.jeopardy {
  background: rgb(233, 169, 22); /* Old browsers */
  background: -moz-linear-gradient(top, rgba(233, 169, 22, 1) 0%, rgba(219, 120, 0, 1) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(233, 169, 22, 1) 0%, rgba(219, 120, 0, 1) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(233, 169, 22, 1) 0%, rgba(219, 120, 0, 1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

.fixed-header .sla.breach .secondary--text,
.fixed-header .sla.jeopardy .secondary--text {
  color: white !important;
}

.fixed-header .sla .v-btn {
  margin: 19px 0 0 19px;
}

.fixed-header .action .v-btn {
  margin: 19px 0 0 19px;
}

.fixed-header .vert-dots .v-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fixed-header .label {
  margin-bottom: 2px;
}

.fixed-header .sub-header {
  margin-top: -3px;
}

.fixed-header .status {
  background: #09a1b0;
  color: white;
}

.fixed-header .header-text {
  max-width: 230px;
  padding-top: 12px;
}

.fixed-header .presence {
  white-space: nowrap;
  display: inline-block;
}

.case-summary-fields {
  height: 60px;
}

.summary-field-wrapper {
  width: 20%;
  padding-top: 12px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.summary-field-wrapper:last-of-type {
  border: none;
}

.fixed-header h4 {
  line-height: 1.2em;
}
</style>
